/**
 * Drives each [data-countdown] element between two fully separate, independently
 * worded states (never concatenates text, to avoid mismatched combinations):
 *   - [data-countdown-active]: prefix + live "Xh Ym" value + suffix, shown before
 *     today's order cutoff (data-cutoff-hour / data-cutoff-minute, 24h local time).
 *   - [data-countdown-expired]: a single standalone sentence, shown once the
 *     cutoff has passed.
 * Re-checks once a minute.
 */
(function () {
  function render(root) {
    var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'), 10) || 0;
    var cutoffMinute = parseInt(root.getAttribute('data-cutoff-minute'), 10) || 0;
    var activeEl = root.querySelector('[data-countdown-active]');
    var expiredEl = root.querySelector('[data-countdown-expired]');

    var now = new Date();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, cutoffMinute, 0, 0);
    var diffMs = cutoff.getTime() - now.getTime();

    if (diffMs <= 0) {
      // Setting style.display directly (not just the `hidden` attribute) because
      // the active span also carries an inline `display: inline-flex`, which would
      // otherwise outrank `[hidden]`'s UA-stylesheet `display: none`.
      if (activeEl) {
        activeEl.hidden = true;
        activeEl.style.display = 'none';
      }
      if (expiredEl) {
        expiredEl.hidden = false;
        expiredEl.style.display = '';
      }
      return;
    }

    var valueEl = root.querySelector('[data-countdown-value]');
    if (valueEl) {
      var totalMinutes = Math.ceil(diffMs / 60000);
      var hours = Math.floor(totalMinutes / 60);
      var minutes = totalMinutes % 60;
      valueEl.textContent = hours > 0 ? hours + 'h ' + minutes + 'm' : minutes + 'm';
    }
    if (activeEl) {
      activeEl.hidden = false;
      activeEl.style.display = 'inline-flex';
    }
    if (expiredEl) {
      expiredEl.hidden = true;
      expiredEl.style.display = 'none';
    }
  }

  function tick() {
    document.querySelectorAll('[data-countdown]').forEach(render);
  }

  tick();
  setInterval(tick, 30000);
})();
